/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function() {
  
  $('.accordion > a').on('click', function(e) {
    e.preventDefault();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).siblings('.accordion-content').slideUp(200);
      $('.accordion > a i').removeClass('fa-minus').addClass('fa-plus');
    } else {
      $('.accordion > a i').removeClass('fa-minus').addClass('fa-plus');
      $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
      $('.accordion > a').removeClass('active');
      $(this).addClass('active');
      $('.accordion-content').slideUp(200);
      $(this).siblings('.accordion-content').slideDown(200);
    }
  });
  
});
   
